export function CountdownIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7002 1.66675H7.30019C4.16686 1.66675 3.92519 4.48341 5.61686 6.01675L14.3835 13.9834C16.0752 15.5167 15.8335 18.3334 12.7002 18.3334H7.30019C4.16686 18.3334 3.92519 15.5167 5.61686 13.9834L14.3835 6.01675C16.0752 4.48341 15.8335 1.66675 12.7002 1.66675Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
